<template>
  <div class="poster">
    <div style="width: 100%; display: flex; justify-content: center;">
      <img :src="imgPath" width="375px" alt="">
    </div>

    <record-poster ref="clazzPoster" :poster-data="recordPosterData" @success="success" @fail="fail" />
  </div>
</template>

<script>
import { Toast, Popup, Button } from 'vant'
import RecordPoster from '@/components/Poster/RecordPoster'
import ClazzPoster from '@/components/Poster/ClazzPoster'
import img2 from '@/assets/images/poster/column.png'

export default {
  name: 'poster',
  components: {
    RecordPoster,
    [Popup.name]: Popup,
    [Button.name]: Button,
    ClazzPoster
  },
  data () {
    return {
      show: false,
      imgPath: '',
      chickenSoup: '逆风的方向，更适合飞翔， 我不怕千万人阻挡，只怕自己投降。',
      posterTemplates: [
        'http://running-upload.oss-cn-hangzhou.aliyuncs.com/poster_template/clazz/clazz_poster_01.jpg',
        'http://running-upload.oss-cn-hangzhou.aliyuncs.com/poster_template/clazz/clazz_poster_02.png',
        'http://running-upload.oss-cn-hangzhou.aliyuncs.com/poster_template/clazz/clazz_poster_04.jpg'
      ],
      clazzPosterData: {
        clazz_name: '班级名称班级名称',
        day_num: 30,
        day_distance: 3,
        enroll_end_time: '12月25日24点',
        join_start_time: '12月25日0点',
        join_end_time: '12月28日24点'
      },
      recordPosterData: {
        is_vertical: true,
        // bg_img: img1,
        bg_img: img2,
        chicken_soup: '',
        days: 200,
        day_distance: 111,
        day_minutes: 100,
        total_distance: 2222
      }
    }
  },
  computed: {
  },
  created () {
    const q = this.$route.query
    this.recordPosterData.bg_img = q.b ? q.b : img2
    this.recordPosterData.is_vertical = q.v ? q.v === '1' : true
    this.recordPosterData.chicken_soup = q.s ? q.s : this.chickenSoup

    this.$store.dispatch('setUserProfile', {
      avatar_url: 'http://running-upload.oss-cn-hangzhou.aliyuncs.com/images/default_avatar.jpg',
      nickname: '预览用户000001',
      uuid: 10424537711
    })
  },
  methods: {
    onRend (image) {
      Toast.loading({ duration: 0, forbidClick: true, loadingType: 'spinner' })
      this.$refs.clazzPoster.renderByBg(image)
    },
    success (src) {
      this.show = true
      this.imgPath = src
      Toast.clear()
    },
    fail (err) {
      Toast.clear()
      console.log('fail', err)
    }
  }
}
</script>

<style lang="scss">
.poster {
  // .help-text {
  //     position: absolute;
  //     color: #fff;
  //     top: 160px;
  //     z-index: 2002;
  //     font-size: 40px;
  //     width: 750px;
  //     text-align: center;
  //   }
  .van-popup {
    width: 600px;
  }
  .title {
    padding: 100px 0 20px;
    text-align: center;
    font-size: 30px;
    font-weight: bold;
  }
  .poster_list_wrap {
    margin-top: 80px;
    /* 水平滚动 */
    overflow-x: scroll;
    /* 垂直隐藏 */
    overflow-y: hidden;
    width: 100%;
  }
  .poster_list {
    display: flex;
    // width: 200%;
    flex-flow: row nowrap;
    overflow-x: scroll;
    img {
      width: 360px;
      margin-right: 20px;
    }
  }
}
</style>
